import React, { useContext } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import AltRouteIcon from '@material-ui/icons/CallSplit';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { I18nContext } from 'translations';
import { formatCostTemporal } from 'utils';

// Local card instead of components/Booking/EstimatedData/CardEstimatedData — that one is
// shared with the classic booking view (centered, no icon) and this redesign needs an
// icon + left-aligned label/value layout that the classic view doesn't want.
function EstimatedCard({ icon, label, value }) {
  return (
    <Paper elevation={0} style={{ border: '1px solid #E0DCE6', borderRadius: 8, padding: '12px 14px' }}>
      <Typography
        component="div"
        variant="caption"
        color="textSecondary"
        style={{ display: 'flex', alignItems: 'center', gap: 6, textTransform: 'uppercase', letterSpacing: 0.4 }}
      >
        {icon}
        {label}
      </Typography>
      <Typography variant="body1" color="textPrimary" style={{ fontWeight: 700, marginTop: 4 }}>
        {value}
      </Typography>
    </Paper>
  );
}

// Sibling of components/Booking/EstimatedData for the classic booking view. It reads
// straight from the route payload (estimated_value/estimated_distance/estimated_time),
// which the backend already resolves per company filter and visibility level — see
// Pibox::DeliveryRoutes::WebView#estimated_value/#estimated_time. Unlike the classic
// component, distance/time arrive already formatted as text ("8 km", "25 mins"), so they
// are rendered as-is instead of going through convertToKm/convertToMin.
export default function RouteEstimatedData({ route }) {
  const { translate } = useContext(I18nContext);

  return (
    <Grid
      container
      alignItems="stretch"
      style={{ padding: '20px 10px' }}
      spacing={2}
      data-testid="route-estimated-data"
    >
      <Grid item md={4} sm={4} xs={12} className="padding0-xs2">
        <EstimatedCard
          icon={<DescriptionOutlinedIcon fontSize="small" />}
          label={translate('app.booking.estimatedValue')}
          value={route?.estimated_value ? formatCostTemporal(route.estimated_value) : '-'}
        />
      </Grid>
      <Grid item md={4} sm={4} xs={12} className="padding0-xs2">
        <EstimatedCard
          icon={<AltRouteIcon fontSize="small" />}
          label={translate('app.booking.distance')}
          value={route?.estimated_distance || '-'}
        />
      </Grid>
      <Grid item md={4} sm={4} xs={12} className="padding0-xs2">
        <EstimatedCard
          icon={<AccessTimeIcon fontSize="small" />}
          label={translate('app.booking.estimatedTime')}
          value={route?.estimated_time || '-'}
        />
      </Grid>
    </Grid>
  );
}
